import { Perfil } from "src/app/model/perfil";

export class Usuario {
    id: number;
    username: string;
    password: string;
    name: string;
    ativo: boolean;
    perfil: number;

    constructor(
        id: number,
        username: string,
        password: string,
        name: string,
        ativo: boolean,
        perfil: number
    ) {
        this.id = id;
        this.username = username;
        this.password = password;
        this.name = name;
        this.ativo = ativo;
        this.perfil = perfil;
    }
}